import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import infoList from "@/mixins/infoList";
import { loadAnalysis } from "@/api/data";
import DataOptions from "../../../components/timeList/dataOptions.vue";
import ChannelOptions from "../../../components/serverList/channelOptions.vue";
export default {
  mixins: [infoList],
  components: {
    DataOptions: DataOptions,
    ChannelOptions: ChannelOptions
  },
  data: function data() {
    return {
      listApi: loadAnalysis,
      value: "",
      inputNum: "",
      changeName: "",
      searchInfo: {
        grouping: "date_str",
        server_id: []
      },
      grouping: "",
      editableTabs: [{
        value: "date_str",
        label: "日期"
      }, {
        value: "device_type",
        label: "设备类型"
      }, {
        value: "app_name",
        label: "游戏类型"
      }],
      deviceOptions: [{
        value: 0,
        label: "全部"
      }, {
        value: 1,
        label: "安卓"
      }, {
        value: 2,
        label: "ios"
      }, {
        value: 3,
        label: "pc"
      }, {
        value: 4,
        label: "其他"
      }],
      // H5链接，微信小游戏，H5微端，原生端
      appOptions: [{
        value: 0,
        label: "全部"
      }, {
        value: 1,
        label: "H5链接"
      }, {
        value: 2,
        label: "微信小游戏"
      }, {
        value: 3,
        label: "H5微端"
      }, {
        value: 4,
        label: "原生端"
      }],
      titleName: "",
      rangeList: [],
      formData: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")]
    };
  },
  watch: {
    value: function value(newVal) {
      this.titleName = newVal;
    }
  },
  methods: {
    checkPage: function checkPage() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var key;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.searchInfo.sdate = _this.formData[0];
              _this.searchInfo.edate = _this.formData[1];
              _context.next = 4;
              return _this.getTableData();
            case 4:
              _this.rangeList = [];
              for (key in _this.tableDataCount.loading_percent) {
                _this.rangeList.push(key);
              }
              _this.grouping = _this.searchInfo.grouping;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    open2: function open2() {
      this.$notify({
        title: "加载统计",
        message: "(1)根据研发上报的游戏加载日志，统计到达对应加载进度的玩家数量。" + "(2)可根据日期，设备类型（安卓、IOS、其他），游戏类型（H5链接，微信小游戏，H5微端，原生端）查询对应条件的加载统计进度" + "(3)显示打开游戏数量，到达对应进度的玩家数量（同时显示对应进度的玩家百分比、以打开游戏数量为基数）",
        duration: 0
      });
    },
    getSummaries: function getSummaries(param) {
      var _this2 = this;
      var h = this.$createElement;
      var columns = param.columns;
      var sums = [];
      columns.forEach(function (column, index) {
        //设置第一列的合计值
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        sums[index] = function () {
          var el = h("div", [h("div", {
            "class": "numClass"
          }, [_this2.tableDataCount.loading_percent[column.property].num]), h("div", {
            "class": "propClass"
          }, ["(", _this2.tableDataCount.loading_percent[column.property].prop, "%)"])]);
          return el;
        }();
        return;
      });
      return sums;
    }
  }
};